module.exports = __webpack_public_path__ + "static/media/Matlandia4_przewodnik_po_zadaniach.92d1afcf.pdf";